<template>
    <div class="contenido">
        <h3 class="titulo">¡No has iniciado sesión o tu sesión ha expirado!</h3>
        <p class="subtitulo">Por favor ingresa tu usuario y tu contraseña...</p>

        <b-row class="p-2">
            <b-col cols="12" md="4"></b-col>
            <b-col cols="12" md="4" class="mb-5">
                <Login @retornar="retornar"/>
            </b-col>
            <b-col cols="12" md="4"></b-col>
        </b-row>
    </div>
</template>

<script>
import Login from '@/modules/colonos/components/Login.vue'

export default {
    name: 'NoSesion',
    components: {
        Login
    },
    props: {
    },
    methods: {
        retornar() {
            const redirectTo = this.$route.query.redirect || '/inicio'
            this.$router.push(redirectTo)
        }
    },
    computed: {
    }
}
</script>

<style scoped>
.contenido{
    min-height: 500px;
}

.titulo {
    padding: 15px 0;
    text-align: center;
}

.subtitulo {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
}
</style>